export enum FREE_EPAY_SETUP_CREDITS_ENUM {
    Growth = 5,
    Premium = 15
}
